<form [formGroup]="rabatForm" autocomplete="off">
  <mat-tab-group (selectedTabChange)="tabChanged($event)" [selectedIndex]="tabIndex" [color]="'accent'">
    <mat-tab label="Rabat i %">
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Rabat ({{ rabatPeriodsuffix }})</mat-label>
          <input type="number" formControlName="rabatProcent" matInput />
          <span matSuffix>%</span>
        </mat-form-field>
      </div>
    </mat-tab>
    <mat-tab [label]="'Rabat (' + rabatPeriodsuffix + ') i kr/øre'">
      <div class="form-row">
        <mat-form-field appearance="outline" class="wider-input">
          <mat-label>
            Rabat ({{ rabatPeriodsuffix }})
            @if (isPrivatKunde) {
              <span>inkl. moms</span>
            }
            @if (!isPrivatKunde) {
              <span>ekskl. moms</span>
            }
          </mat-label>
          <input type="number" formControlName="rabatKontant" matInput />
          <span matSuffix>Kr.</span>
        </mat-form-field>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="form-row flex">
    <div class="form-row form-row--inline">
      <mat-form-field appearance="outline">
        <mat-label>Fakturatekst</mat-label>
        <input type="text" id="rabatTekst" formControlName="rabatTekst" matInput />
      </mat-form-field>
    </div>
    <div class="form-row form-row--inline margin--left-m">
      <mat-form-field appearance="outline">
        <mat-label>Fordeling</mat-label>
        <mat-select formControlName="rabatSplit">
          <mat-option [value]="0">Betalt af OK</mat-option>
          <mat-option [value]="100">Betalt af servicepartner</mat-option>
          <mat-option [value]="-1">Betalt ifølge servicepartnerandel</mat-option>
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </div>
  </div>
  <mat-slide-toggle color="primary" formControlName="engangsRabat">Engangsrabat</mat-slide-toggle>
  <div>
    @if (rabatForm?.hasError('rabat') && (rabatProcent.dirty || rabatKontant.dirty)) {
      <mat-error class="red">
        {{ rabatForm.errors.rabat }}
      </mat-error>
    }
  </div>
</form>
